// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"c975f587","141":"768511c0","215":"7371815f","220":"a031554c","322":"b840cbe2","389":"e74ad687","494":"54338682","537":"c8eed638","549":"3051a152","593":"fec0fb51","648":"23f02029","848":"44fbdb58","886":"5caf1768","922":"c77ddc1a"}[chunkId] + ".chunk.js";
};